"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdRenderInBody = _interopRequireDefault(require("cccisd-render-in-body"));
var _cccisdCalculator = _interopRequireDefault(require("cccisd-calculator"));
var _reactDnd = require("react-dnd");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var source = {
  beginDrag: function beginDrag(props, monitor, component) {
    component.dragId = setInterval(function () {
      var _monitor$getDifferenc = monitor.getDifferenceFromInitialOffset(),
        x = _monitor$getDifferenc.x,
        y = _monitor$getDifferenc.y;
      component.handleMousePosition(x, y);
    }, 20);
    return {};
  },
  endDrag: function endDrag(props, monitor, component) {
    component.fixInitialPosition();
    clearInterval(component.dragId);
  }
};
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview()
  };
}
var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);
  var _super = _createSuper(Component);
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      x: _this.props.calculatorPosition.x,
      y: _this.props.calculatorPosition.y
    });
    _defineProperty(_assertThisInitialized(_this), "fixInitialPosition", function () {
      _this.props.saveCalculatorPosition(_this.state.x, _this.state.y);
    });
    _defineProperty(_assertThisInitialized(_this), "handleMousePosition", function (x, y) {
      var _this$wrapper = _this.wrapper,
        clientWidth = _this$wrapper.clientWidth,
        clientHeight = _this$wrapper.clientHeight;
      var _window = window,
        innerWidth = _window.innerWidth,
        innerHeight = _window.innerHeight;
      _this.setState({
        x: Math.max(0, Math.min(x + _this.props.calculatorPosition.x, innerWidth - clientWidth)),
        y: Math.max(0, Math.min(y + _this.props.calculatorPosition.y, innerHeight - clientHeight))
      });
    });
    return _this;
  }
  _createClass(Component, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Show empty image as a placeholder (it means no placeholder)
      var img = new Image();
      img.onload = function () {
        return _this2.props.connectDragPreview(img);
      };
      img.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_react["default"].createElement(_cccisdRenderInBody["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-dialog ".concat(_style["default"].wrapper),
        style: {
          left: this.state.x,
          top: this.state.y
        },
        ref: function ref(elem) {
          _this3.wrapper = elem;
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-content"
      }, this.props.connectDragSource( /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-header",
        style: {
          cursor: 'grab'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "close",
        onClick: this.props.close
      }, "\xD7"), /*#__PURE__*/_react["default"].createElement("h4", {
        className: "modal-title"
      }, "Calculator"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-body",
        style: {
          backgroundColor11: '#d9edf7'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdCalculator["default"], null)))));
    }
  }]);
  return Component;
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  connectDragSource: _propTypes["default"].func.isRequired,
  connectDragPreview: _propTypes["default"].func.isRequired,
  close: _propTypes["default"].func,
  calculatorPosition: _propTypes["default"].object,
  saveCalculatorPosition: _propTypes["default"].func
});
_defineProperty(Component, "defaultProps", {
  calculatorPosition: {
    x: 0,
    y: 0
  }
});
var _default = (0, _reactDnd.DragSource)('Calculator', source, collect)(Component);
exports["default"] = _default;